import {InputProvider} from 'components/common/CartItemBuilder/providers/InputProvider'
import moment from 'moment'

export const MinimizedCalendar = () => {
  const date = InputProvider.useDate('optional')
  return <div>{date ? moment(date).format('dddd, MMM DD, YYYY') : null}</div>
}
